import { createContext, useContext, type ReactNode } from 'react';

import type { EnterprisePartner, PartnerConfigChannel } from '~/gql/graphql';

export type { EnterprisePartner } from '~/gql/graphql';

type PartnerConfigContextValue = {
  config: EnterprisePartner | null;
  activeChannel: PartnerConfigChannel | null;
};

const PartnerConfigContext = createContext<PartnerConfigContextValue>({ config: null, activeChannel: null });

export function PartnerConfigProvider({
  children,
  config,
  activeChannel = null,
}: {
  children: ReactNode;
  config: EnterprisePartner | null;
  activeChannel?: PartnerConfigChannel | null;
}) {
  return <PartnerConfigContext.Provider value={{ config, activeChannel }}>{children}</PartnerConfigContext.Provider>;
}

export function usePartnerConfig(): EnterprisePartner | null {
  return useContext(PartnerConfigContext).config;
}

export function useActiveChannel(): PartnerConfigChannel | null {
  return useContext(PartnerConfigContext).activeChannel;
}
